export default "__VITE_ASSET__ywq1$e7l__"